import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  BasketballGameStatistic,
  Game, GameBasketballPositionLocalization,
  GameUser,
} from '@mtgame/core';

@Component({
  selector: 'mtg-basketball-game-mvp-users',
  templateUrl: './basketball-game-mvp-users.component.html',
  styleUrls: ['./basketball-game-mvp-users.component.scss', '../../game/styles/mvp-users.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketballGameMvpUsersComponent implements OnChanges {
  @Input()
  mvpUsers: GameUser[];
  @Input()
  game: Game;
  @Input()
  statistic: BasketballGameStatistic[];
  userStatistic: {[key: number]: BasketballGameStatistic} = {};
  basketballPositionLocalization = GameBasketballPositionLocalization;
  teamMvpUsers: GameUser[];
  competitorTeamMvpUsers: GameUser[];

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.mvpUsers || changes.game) && this.game && this.mvpUsers) {
      this.teamMvpUsers = this.mvpUsers.filter(item => item.teamUser.teamId === this.game.team.id);
      this.competitorTeamMvpUsers = this.mvpUsers.filter(item => item.teamUser.teamId === this.game.competitorTeam.id);
    }
    if (changes.statistic && this.statistic) {
      this.userStatistic = this.statistic.reduce((acc, item) => ({
        ...acc,
        [item.gameUserId]: item,
      }), {});
    }
  }

  getUserStatistic(user: GameUser): {title: string, value: number}[] {
    const userStatistic = this.userStatistic[user.id] || new BasketballGameStatistic();
    return [
      {title: 'очки', value: userStatistic.points},
      {title: 'подборы', value: userStatistic.rebounds},
      {title: 'блоки', value: userStatistic.blocks},
      {title: 'перехваты', value: userStatistic.steals},
      {title: '3х очковые', value: userStatistic.threePointsMade}
    ].sort((a, b) => b.value - a.value).slice(0, 3);
  }
}
